import { render, staticRenderFns } from "./PreviewTreatment.vue?vue&type=template&id=2f6de09f&scoped=true"
import script from "./PreviewTreatment.vue?vue&type=script&lang=js"
export * from "./PreviewTreatment.vue?vue&type=script&lang=js"
import style0 from "./PreviewTreatment.vue?vue&type=style&index=0&id=2f6de09f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6de09f",
  null
  
)

export default component.exports